import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import t from 'tcomb-form';
import { doUpdateSharedStory, doSaveMe } from '../../actions';
import CityAutosuggestFactory from '../../components/CityAutosuggest';
import { WebsiteRefinement, WebsiteTransformer } from '../../utils/tcomb-utils';
import { objectToFormData } from '../../utils/index';

const AgeRange = t.enums({
  1: 'below 18',
  2: '18 - 24',
  3: '25 - 35',
  4: '35 - 55',
  5: 'over 55'
});

const SharedStoryAgeSchema = t.struct({
  age_range: AgeRange
});

const formAgeOptions = {
  auto: 'none',
  fields: {
    age_range: {
      error: 'Please select an age range',
      nullOption: { value: null, text: 'What is your age range?' }
    }
  }
}

const SharedStorySchema = t.struct({
  like_website: t.maybe(t.String),
  suggestions: t.maybe(t.String)
});

const formOptions = {
  auto: 'none',
  fields: {
    like_website: {
      type: 'textarea',
      label: <span>What do you like most about the WorldWideWomen website?</span>,
      attrs: {
        maxLength: 200,
      }
    },
    suggestions: {
      type: 'textarea',
      label: <span>
        <p className="internalUseOnly">
          The following questions are for our internal use only. We will not share your responses publicly.
        </p>
        <span>Do you have any suggestions for how we can improve the site?</span>
        </span>,
      attrs: {
        maxLength: 200,
      }
    }
  }
};

class SharedStoryStep4 extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    formOptions: formOptions,
    formAgeOptions: formAgeOptions,
    formValues: {},
    formAgeValue: {}
  }

  onFormChange = formValues => {
    this.setState({ formValues });
  }

  onFormAgeChange = formAgeValue => {
    this.setState({ formAgeValue });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const value = this.refs.sharedStoryForm.getValue();
    const ageValue = this.refs.userInfoForm.getValue();
    if(!value) {
      return;
    } else {

      var content = Object.assign({}, value);
      var ageContent = Object.assign({}, ageValue)
      content.pk = this.props.sharedStory.db_id;


      this.props.doUpdateSharedStory(content);

      this.props.doSaveMe(ageContent);
      this.props.goToStep5();

      if (typeof(window) !== "undefined") {
        window.scrollTo(0,0)
      }
      this.resetForm();
    }
  }

  resetForm = (e) => {
    this.setState({ formValues: {
      like_website: '',
      suggestions: ''
    }})
  }

  render() {

    return(
    <div className="sharedStory-step2Wrapper">
      <div className="sharedStory-progressbar">
        <img src="/images/shared_stories/apply_step03.png" />
      </div>
      <div className="sharedStoryWrapper sharedStoryWrapper-formWrapper">
        <form className="shared-story-form" onSubmit={(e)=>{ e.prevenDetault(); }}>
        <t.form.Form ref="sharedStoryForm" value={this.state.formValues} onChange={this.onFormChange} type={SharedStorySchema} options={this.state.formOptions} />

        </form>

        <form className="my-account-form sharedStory-ageSelect" onSubmit={(e)=>{ e.prevenDetault(); }}>
        <t.form.Form ref="userInfoForm" value={this.state.formAgeValue} onChange={this.onFormAgeChange} type={SharedStoryAgeSchema} options={this.state.formAgeOptions} />

        <button onClick={this.handleSubmit} className="my-account-submit submitButton button-primary" type="submit">Submit</button>
        </form>
      </div>
    </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doUpdateSharedStory,
    doSaveMe
  }
)(SharedStoryStep4);



// WEBPACK FOOTER //
// ./src/components/sharedStory/SharedStoryStep4.jsx